require('./optionGroupDropDown.i18n.json');
require('./optionGroupDropDown.tpl.html');
require('./optionGroupDropDownController.js');

const OptionGroupDropDownComponent = {
    templateUrl: '/configuration/formEditor/content/form/componentSettings/optionGroup/optionGroupDropDown/optionGroupDropDown.tpl.html',
    controller: 'optionGroupDropDownController',
    bindings: {
        selectedField: '<',
        name: '<',
        label: '<',
        values: '<',
        value: '<',
        isDisabled: '<',
        scrollableContainerSelector: '<',
        allowClear: '<',
        allowNewValues: '<'
    }
};

angular.module('ums.configuration')
    .component('uiOptionGroupDropDown', OptionGroupDropDownComponent);
